export default __webpack_public_path__ + "static/media/reject-offer.a0bf7411.svg";